import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss'],
})
export class AdvertisementComponent {
  @ViewChild('carouselTrack') carouselTrack!: ElementRef;
  @ViewChild('carouselContainer') carouselContainer!: ElementRef;
  @Input() size = 'large';

  currentSlide = 0;
  autoSlideInterval: any;
  isDragging = false;
  startX = 0;
  startScrollLeft = 0;

  advertisements = [
    {
      id: 1,
      title: 'Free Delivery',
      description: 'Free shipping on all products',
      imageUrl: 'https://images.mashhoorplus.in/file/17442781757503.jpg',
    },
    {
      id: 2,
      title: 'Discounts',
      description: '10% off on prepaid orders',
      imageUrl: 'https://images.mashhoorplus.in/file/17442779759603.jpg',
    },
    {
      id: 3,
      title: 'Free Shipping',
      description: 'Get upto 50% off on combos',
      imageUrl: 'https://images.mashhoorplus.in/file/17442813190682.png',
    },
  ];

  ngAfterViewInit(): void {
    // Start automatic sliding
    this.startAutoSlide();

    // Set up touch/mouse events for manual sliding
    const track = this.carouselTrack.nativeElement;

    track.addEventListener('mousedown', this.startDrag.bind(this));
    track.addEventListener('touchstart', this.startDrag.bind(this));

    track.addEventListener('mousemove', this.drag.bind(this));
    track.addEventListener('touchmove', this.drag.bind(this));

    track.addEventListener('mouseup', this.endDrag.bind(this));
    track.addEventListener('touchend', this.endDrag.bind(this));
    track.addEventListener('mouseleave', this.endDrag.bind(this));
  }

  startAutoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 2000); // Change slide every 5 seconds
  }

  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.updateCarouselPosition();

    // Reset the timer
    this.stopAutoSlide();
    this.startAutoSlide();
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.advertisements.length;
    this.updateCarouselPosition();
  }

  updateCarouselPosition(): void {
    const track = this.carouselTrack.nativeElement;
    const slideWidth = this.carouselContainer.nativeElement.offsetWidth;
    track.style.transform = `translateX(-${slideWidth * this.currentSlide}px)`;
  }

  startDrag(e: MouseEvent | TouchEvent): void {
    this.isDragging = true;

    if (e instanceof MouseEvent) {
      this.startX = e.pageX;
    } else {
      this.startX = e.touches[0].pageX;
    }

    this.startScrollLeft =
      this.currentSlide * this.carouselContainer.nativeElement.offsetWidth;

    // Stop auto-sliding while dragging
    this.stopAutoSlide();
  }

  drag(e: MouseEvent | TouchEvent): void {
    if (!this.isDragging) return;

    e.preventDefault();

    let currentX;
    if (e instanceof MouseEvent) {
      currentX = e.pageX;
    } else {
      currentX = e.touches[0].pageX;
    }

    const diff = this.startX - currentX;
    const track = this.carouselTrack.nativeElement;
    const slideWidth = this.carouselContainer.nativeElement.offsetWidth;

    track.style.transform = `translateX(-${this.startScrollLeft + diff}px)`;
  }

  endDrag(e?: MouseEvent | TouchEvent): void {
    if (!this.isDragging) return;
    this.isDragging = false;

    let endX;
    if (e instanceof MouseEvent) {
      endX = e.pageX;
    } else if (e instanceof TouchEvent) {
      endX = e.changedTouches[0].pageX;
    } else {
      // If the event is undefined (mouseleave), use the current position
      endX = this.startX;
    }

    const diff = this.startX - endX;
    const slideWidth = this.carouselContainer.nativeElement.offsetWidth;
    const threshold = slideWidth * 0.2; // 20% threshold for slide change

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.currentSlide = Math.min(
          this.currentSlide + 1,
          this.advertisements.length - 1
        );
      } else {
        this.currentSlide = Math.max(this.currentSlide - 1, 0);
      }
    }

    this.updateCarouselPosition();

    // Restart auto-sliding
    this.startAutoSlide();
  }
  ngOnDestroy(): void {
    this.stopAutoSlide();

    // Remove event listeners
    const track = this.carouselTrack?.nativeElement;
    if (track) {
      track.removeEventListener('mousedown', this.startDrag.bind(this));
      track.removeEventListener('touchstart', this.startDrag.bind(this));
      track.removeEventListener('mousemove', this.drag.bind(this));
      track.removeEventListener('touchmove', this.drag.bind(this));
      track.removeEventListener('mouseup', this.endDrag.bind(this));
      track.removeEventListener('touchend', this.endDrag.bind(this));
      track.removeEventListener('mouseleave', this.endDrag.bind(this));
    }
  }
}
